import {
  LogGroupNotesDto,
  LogGroupNotesGetDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  OptionItemDto,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class LogGroupNotesService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getByParameters(
    params: {
      /**  */
      parameters: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<LogGroupNotesDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-group-notes/{parameters}';
      url = url.replace('{parameters}', params['parameters'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      parameters: string;
      /**  */
      notes?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<LogGroupNotesGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-group-notes/{parameters}';
      url = url.replace('{parameters}', params['parameters'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { notes: params['notes'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
